<script setup lang="ts">
import { router } from "@/app/router";
import QitBtn from "@/shared/components/buttons/qit-button.vue";
import { useAbilityRoute } from "@/shared/environment/ability-route";
import { encodeParamArrayToString } from "@/shared/environment/ability-route-helper";
import { CommonRouteAliases } from "@/shared/environment/common-route-aliases";
import { toRefs } from "vue";
import WidgetCard from "@/shared/components/widgets/widget-card.vue";

const props = defineProps<{
    productId: string | null;
    pathToRootAssembly: string[] | null;
    hasSubAssemblies: boolean;
}>();

const emits = defineEmits<{
    (e: "openAssemblyNavigation"): void;
}>();

const { productId, pathToRootAssembly, hasSubAssemblies } = toRefs(props);

const { getPathToChild } = useAbilityRoute();

function identifyPartClicked() {
    //if there is exactly one mechanic with no subassemblies in the root-assembly-list, jump directly to the partslist instead of opening the assembly navigation
    if (!hasSubAssemblies.value && productId.value && pathToRootAssembly.value) {
        router.push(
            getPathToChild(CommonRouteAliases.mechanic, {
                [CommonRouteAliases.mechanic]: encodeParamArrayToString(pathToRootAssembly.value),
            })
        );
    } else {
        emits("openAssemblyNavigation");
    }
}
</script>

<template>
    <WidgetCard
        icon="fa-light fa-location-pin icon-light-color"
        :title="$t('mechanic.Installation location')"
        :description="$t('mechanic.Identify components based on their location')"
    >
        <template #button>
            <div class="flex justify-end">
                <QitBtn
                    color="secondary"
                    data-qs="identify-part-item-button"
                    :label="$t('mechanic.Select installation location')"
                    @click="identifyPartClicked"
                />
            </div>
        </template>
    </WidgetCard>
</template>
